var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"InputNode",class:_vm.getClass(),attrs:{"data-node-id":"0","data-node-name":_vm.node.name}},[_vm._v(" Inputs ")])}
var staticRenderFns = []

export { render, staticRenderFns }